import type { Lang } from '../constants';
import { t } from '../i18n';

interface LoadingSpinnerProps {
  lang: Lang;
  inline?: boolean;
}

export function LoadingSpinner({ lang, inline }: LoadingSpinnerProps) {
  const strings = t(lang);

  if (inline) {
    return (
      <span className="ds-c-spinner ds-c-spinner--small" role="status">
        <span className="ds-u-visibility--screen-reader">{strings.loading}</span>
      </span>
    );
  }

  return (
    <div className="app-library-search__loading ds-u-text-align--center ds-u-padding--4">
      <span className="ds-c-spinner" role="status">
        <span className="ds-u-visibility--screen-reader">{strings.loading}</span>
      </span>
    </div>
  );
}
